

// @mui material components
import Card from "@mui/material/Card";
// import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Billing page components
import Transaction from "layouts/billing/components/Transaction";

function Transactions() {
  return (
    <Card className="h-100">
      <DSBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
        <DSTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Last 30 days Transactions
        </DSTypography>
        <DSBox display="flex" alignItems="flex-start">
          <DSBox color="text" mr={0.5} lineHeight={0}>
            <Icon color="inherit" fontSize="small">
              date_range
            </Icon>
          </DSBox>
          <DSTypography variant="button" textColor="text" fontWeight="regular">
            01 - 30 Sep 2022
          </DSTypography>
        </DSBox>
      </DSBox>
      <DSBox pt={3} pb={2} px={2}>
        <DSBox mb={2}>
          <DSTypography
            variant="caption"
            textColor="text"
            fontWeight="bold"
            textTransform="uppercase"
          >
            newest
          </DSTypography>
        </DSBox>
        <DSBox
          component="ul"
          display="flex"
          flexDirection="column"
          p={0}
          m={0}
          customClass="no-list-style"
        >
          <Transaction
            color="success"
            icon="arrow_upward"
            name="MuSE Pte Ltd"
            description="22 Sep 2022, at 10:30 PM"
            value="+ $ 1,500"
          />
          <Transaction
            color="error"
            icon="arrow_downward"
            name="Flix Ind"
            description="27 Sep 2022, at 08:30 AM"
            value="- $ 200"
          />
        </DSBox>
        <DSBox mt={1} mb={2}>
          <DSTypography
            variant="caption"
            textColor="text"
            fontWeight="bold"
            textTransform="uppercase"
          >
            last week
          </DSTypography>
        </DSBox>
        <DSBox
          component="ul"
          display="flex"
          flexDirection="column"
          p={0}
          m={0}
          customClass="no-list-style"
        >
          <Transaction
            color="success"
            icon="arrow_upward"
            name="Trent Plc"
            description="16 Sep 2022, at 13:45 PM"
            value="+ $ 1750"
          />
          
          <Transaction
            color="dark"
            icon="priority_high"
            name="Webare Pte Ltd"
            description="18 Sep 2022, at 03:00 AM"
            value="Pending"
          />
        </DSBox>
      </DSBox>
    </Card>
  );
}

export default Transactions;
